<ng-container>
    <span  *ngIf="frequency;else dash"> {{frequency}} </span>
    <ng-template #dash>-</ng-template>
</ng-container>